module.exports = __webpack_public_path__ + "img/bonuses3.2e38571a.png";